<app-chat-card
  class="coming-soon-card"
  [header]="'Track Your Progress! (Coming Soon)'"
  [description]="
    'See your study habits and results to focus on what matters most. Study smarter, not harder.'
  "
  [route]="'/chat'"
>
</app-chat-card>
